'use client';

import { useFeatureFlagEnabled } from '@frameio/feature-flags';

// @todo (SRCH-2455): Remove this hook and make M2 behavior unconditional after rollout.
export const useIsAdvancedSearchM2Enabled = (): boolean =>
  Boolean(useFeatureFlagEnabled('v4.advanced_search.m2'));
